export default __webpack_public_path__ + "static/media/list.df9703df.png";